/* eslint-disable */
import { MESSAGE_RESULT } from '../message.js';
import { UPLOAD_FILE_SIZE_LIMIT, UPLOAD_FILE_SIZE_LIMIT_TEXT } from '../constants.js';
import { removeCrlf } from '../utils.js';
/* eslint-enable */
import { COMMON_LABEL_MAP } from '@components/common/constants';

export const checkCommonItemValid = (item, inputStr, serviceSettingItemsKey) => {
  if (typeof inputStr === 'undefined') return MESSAGE_RESULT.NG;

  const { label, required, maxLength } = item;

  // 共通でチェックするバリデーション
  if (!['industry', 'corpOccupation', 'corpCompanyUse', 'corpMemberType', 'corpPointUserImpossible'].includes(serviceSettingItemsKey)) {
    const requiredValidation = validateRequired(inputStr, required, label);
    if (requiredValidation) return requiredValidation;

    const commonValidation = validateCommonInput(inputStr, maxLength, label);
    if (commonValidation) return commonValidation;
  // プルダウンとラジオ項目のチェック
  } else {
    const retValidation = checkSelectData(inputStr, COMMON_LABEL_MAP[serviceSettingItemsKey]);
    if (retValidation !== '') {
      return retValidation;
    }
  }

  if (inputStr === '' && !required) return MESSAGE_RESULT.OK;

  // 個別にチェックするバリデーション
  switch (serviceSettingItemsKey) {
    case 'docomoID': {
      if (!isValidAlphanumeric(inputStr) && !isEmailValid(inputStr)) {
        return MESSAGE_RESULT.INCORECT_FORMAT(label);
      }
      break;
    }

    case 'nameKana':
    case 'companyNameKana': {
      if (!isKanaNameValid(inputStr)) {
        return MESSAGE_RESULT.NOT_KANA_NAME(label);
      }
      break;
    }

    case 'email': {
      if (!isEmailValid(inputStr)) {
        return MESSAGE_RESULT.INCORECT_FORMAT(label);
      }
      break;
    }

    case 'managementGroup': {
      if (!isValidNumeric(inputStr)) {
        return MESSAGE_RESULT.NOT_NUMERIC(label);
      }
      break;
    }

    case 'employeeCode': {
      if (!isValidAlphanumeric(inputStr)) {
        return MESSAGE_RESULT.NOT_ALPHANUMERIC(label);
      }
      break;
    }

    case 'companyNumber': {
      if (!isValidNumeric(inputStr)) {
        return MESSAGE_RESULT.NOT_NUMERIC(label);
      }
      break;
    }

    case 'phoneNumber': {
      const phoneValidation = validatePhoneNumber(inputStr, label);
      if (phoneValidation) return phoneValidation;
      break;
    }

    case 'companyAddressPostalCode': {
      const postalValidation = validatePostalCode(inputStr, label);
      if (postalValidation) return postalValidation;
      break;
    }

    case 'addressCode': {
      const addressCodeValidation = validateAddressCode(inputStr, label);
      if (addressCodeValidation) return addressCodeValidation;
      break;
    }

    default:
      break;
  }

  return MESSAGE_RESULT.OK;
};

export const checkIndependentItemValid = (item, inputStr, fieldName, formData) => {
  if (typeof inputStr === 'undefined') return MESSAGE_RESULT.NG;

  const { title, required } = item;

  // 共通でチェックするバリデーション（必須項目）
  if (item.inputType !== 'select' && item.inputType !== 'checkbox' && item.inputType !== 'radiobutton' && item.inputType !== 'agree') {
    const requiredValidation = validateRequired(inputStr, required, title);
    if (requiredValidation) return requiredValidation;
  }

  switch (item.inputType) {
    // 選択肢(チェックボックス)
    case 'checkbox':
      return checkIndependentCheckboxData(item, fieldName, formData);

    // 選択肢(ラジオボタン)
    case 'radiobutton':
      return checkIndependentRadiobuttonData(inputStr, item, fieldName, formData);

    // プルダウン
    case 'select':
      return checkIndependentSelectData(inputStr, item);

    // テキスト
    case 'text':
    case 'textarea':
      return checkIndependentTextData(inputStr, item);

    // 規約同意
    case 'agree':
      return checkAgreeRequired(inputStr, required, title);

    // ファイルのアップロード
    case 'file':
      return checkIndependentFileData(inputStr, item);

    default:
      break;
  }

  return MESSAGE_RESULT.OK;
};

const validateRequired = (inputStr, required, label) => {
  if (!inputStr && required) {
    return MESSAGE_RESULT.NOT_INPUT(label);
  }
  return null;
};

export const checkAgreeRequired = (checkValue, required, label) => {
  if (!checkValue && required) {
    return MESSAGE_RESULT.NOT_AGREE_CHECK(label);
  }
  return MESSAGE_RESULT.OK;
};

const validateCommonInput = (inputStr, maxLength, label) => {
  if (isSpaceOnly(inputStr)) {
    return MESSAGE_RESULT.NOT_SPACE;
  }
  if (!isWithinMaxLength(inputStr, maxLength)) {
    return MESSAGE_RESULT.OVER_DIGITS(label, maxLength);
  }
  if (!isNotContainSpecialCharacter(inputStr)) {
    return MESSAGE_RESULT.NOT_SPECIAL_CHARACTER(label);
  }
  return null;
};

const validatePhoneNumber = (inputStr, label) => {
  if (!/^\d+$/.test(inputStr)) {
    return MESSAGE_RESULT.NOT_NUMBER(label);
  }
  if (inputStr.length !== 10 && inputStr.length !== 11) {
    return MESSAGE_RESULT.NOT_PHONE_NUMBER;
  }
  return null;
};

const validateUsage = (inputStr, label, min, max) => {
  if (!/^\d+$/.test(inputStr) || isNaN(Number(inputStr))) {
    return MESSAGE_RESULT.NOT_NUMBER(label);
  }
  if (Number(inputStr) < min || Number(inputStr) > max) {
    return MESSAGE_RESULT.NOT_RANGER(min, max);
  }
  return null;
};

const validatePostalCode = (inputStr, label) => {
  if (!/^\d+$/.test(inputStr)) {
    return MESSAGE_RESULT.NOT_NUMBER(label);
  }
  if (inputStr.length !== 7) {
    return MESSAGE_RESULT.NOT_POSTALCODE;
  }
  return null;
};

const validateAddressCode = (inputStr, label) => {
  if (!isValidNumeric(inputStr)) {
    return MESSAGE_RESULT.NOT_NUMBER(label);
  }
  if (inputStr.length !== 11) {
    return MESSAGE_RESULT.NOT_ADDRESSCODE;
  }
  return null;
};

export const checkValidName = (inputStr, max, itemName) => {
  if (!inputStr) {
    return MESSAGE_RESULT.NOT_INPUT(itemName);
  } else if (isSpaceOnly(inputStr)) {
    return MESSAGE_RESULT.NOT_SPACE;
  } else if (!isWithinMaxLength(inputStr, max)) {
    return MESSAGE_RESULT.OVER_DIGITS(itemName, max);
  } else if (!isNotContainSpecialCharacter(inputStr)) {
    return MESSAGE_RESULT.NOT_SPECIAL_CHARACTER(itemName);
    // } else if (!isNameValid(inputStr)) {
    //   return MESSAGE_RESULT.NOT_NAME(itemName);
  } else {
    return MESSAGE_RESULT.OK;
  }
};
export const checkValidCompanyName = (inputStr, max, itemName) => {
  if (!inputStr) {
    return MESSAGE_RESULT.NOT_INPUT(itemName);
  } else if (isSpaceOnly(inputStr)) {
    return MESSAGE_RESULT.NOT_SPACE;
  } else if (!isWithinMaxLength(inputStr, max)) {
    return MESSAGE_RESULT.OVER_DIGITS(itemName, max);
  } else if (!isNotContainSpecialCharacter(inputStr)) {
    return MESSAGE_RESULT.NOT_SPECIAL_CHARACTER(itemName);
    // } else if (!isNameValid(inputStr)) {
    //   return MESSAGE_RESULT.NOT_NAME(itemName);
  } else {
    return MESSAGE_RESULT.OK;
  }
};
export const checkValidTotalUserIds = (inputStr, itemName) => {
  const min = 1;
  const max = 9999999999;
  if (!inputStr && inputStr !== 0) {
    return MESSAGE_RESULT.NOT_INPUT(itemName);
  } else if (isSpaceOnly(inputStr)) {
    return MESSAGE_RESULT.NOT_SPACE;
  } else if (!/^\d+$/.test(inputStr) || isNaN(Number(inputStr))) {
    return MESSAGE_RESULT.NOT_NUMBER(itemName);
  } else if (inputStr < min || inputStr > max) {
    return MESSAGE_RESULT.NOT_RANGER(min, max);
  } else {
    return MESSAGE_RESULT.OK;
  }
};
export const checkSellerCode = (inputStr, itemName) => {
  if (!inputStr) {
    return MESSAGE_RESULT.OK;
  } else if (isSpaceOnly(inputStr)) {
    return MESSAGE_RESULT.NOT_SPACE;
  } else if (!isNotContainSpecialCharacter(inputStr)) {
    return MESSAGE_RESULT.NOT_SPECIAL_CHARACTER(itemName);
  } else if (!isSellerCode(inputStr)) {
    return MESSAGE_RESULT.NOT_SELLER_CODE;
  } else {
    return MESSAGE_RESULT.OK;
  }
};
export const checkSelectData = (inputStr, itemName) => {
  if (!inputStr) {
    return MESSAGE_RESULT.NOT_SELECT(itemName);
  } else {
    return MESSAGE_RESULT.OK;
  }
};
export const checkIndependentSelectData = (inputStr, item) => {
  try {
    if (!item.required && inputStr === '') {
      return MESSAGE_RESULT.OK;
    }

    // JSON 文字列をパースしてオブジェクトに変換
    const inputObj = JSON.parse(inputStr);
    const valuesObj = JSON.parse(JSON.parse(item.setting).values);

    // inputObj のキーと値が valuesObj に含まれているか確認
    for (const [key, value] of Object.entries(inputObj)) {
      if (valuesObj[key] !== value) {
        return MESSAGE_RESULT.NOT_SELECT(item.title); // 一致しない項目がある場合
      }
    }

    return MESSAGE_RESULT.OK; // 全て一致
  } catch (error) {
    return MESSAGE_RESULT.NOT_SELECT(item.title);
  }
};

// 独自項目のテキストの入力チェック
export const checkIndependentTextData = (inputStr, item) => {
  if (!inputStr) return MESSAGE_RESULT.OK;

  // length check
  if (item.lengthType === 'specify' && inputStr.length !== item.maxLength) {
    return MESSAGE_RESULT.OUTOF_DIGITS(item.title, item.maxLength);
  } else if (item.lengthType === 'upTo' && inputStr.length > item.maxLength) {
    return MESSAGE_RESULT.OVER_DIGITS(item.title, item.maxLength);
  }

  // テキストエリアの場合は改行コードを除去してチェックする
  // lengthは改行コード込みでチェックするので改行コード除去はlength checkの後
  if (item.inputType === 'textarea') {
    inputStr = removeCrlf(inputStr);
  }

  // 特殊記号文字チェック
  const specialCharPattern = /["&'<>]/;
  if (specialCharPattern.test(inputStr)) {
    return MESSAGE_RESULT.NOT_SPECIAL_CHARACTER(item.title);
  }

  // charType, zenhankaku
  switch (item.charType) {
    case 'all': // 全種許可
      if (item.zenhankaku === 'zenkaku') {
        if (!isZenkakuValid(inputStr)) {
          return MESSAGE_RESULT.NOT_ZENKAKU(item.title);
        }
      } else if (item.zenhankaku === 'hankaku') {
        if (!isHankakuValid(inputStr)) {
          return MESSAGE_RESULT.NOT_HANKAKU(item.title);
        }
      }
      break;
    case 'alphaNumber': // 英数字
      if (!isValidAlphanumeric(inputStr)) {
        return MESSAGE_RESULT.NOT_ALPHANUMERIC(item.title);
      }
      break;
    case 'number': // 数字
      if (!isValidNumeric(inputStr)) {
        return MESSAGE_RESULT.NOT_NUMERIC(item.title);
      }
      break;
    case 'kana':  // カタカナ
      if (item.zenhankaku === 'zenkaku') {
        if (!isKanaNameValid(inputStr)) {
          return MESSAGE_RESULT.NOT_KANA_NAME(item.title)
        }
      } else if (item.zenhankaku === 'hankaku') {
        if (!isHankakuKanaNameValid(inputStr)) {
          return MESSAGE_RESULT.NOT_HANKAKU_KANA(item.title)
        }
      }
      break;
    default:
      break;
  }

  return MESSAGE_RESULT.OK; // 全て一致
};

// 独自項目の添付ファイルの入力チェック
export const checkIndependentFileData = (fileData, item) => {
  if (!fileData) return MESSAGE_RESULT.OK;

  // ファイルサイズチェック
  if (fileData.size > UPLOAD_FILE_SIZE_LIMIT) {
    return MESSAGE_RESULT.OVER_FILE_SIZE(item.title, UPLOAD_FILE_SIZE_LIMIT_TEXT);
  }

  // ファイル形式チェック
  switch (fileData.type) {
    case 'image/jpeg':
    case 'image/jpg':
    case 'image/png':
    case 'application/pdf':
      break;
    default:
      return MESSAGE_RESULT.NOT_FILE_TYPE(item.title);
  }

  return MESSAGE_RESULT.OK; // 全て一致
}

export const checkIndependentCheckboxData = (item, fieldName, formData) => {
  try {
    // 送信されたformDataにチェックボックスが含まれていてチェック値がONになっている場合
    let checkboxOnFlg = false;
    for (const key in formData) {
      if (key.includes(fieldName + '_check_') && formData[key]) {
        checkboxOnFlg = true;
        break;
      }
    }

    if (!item.required && !checkboxOnFlg) {
      return MESSAGE_RESULT.OK;
    }
    // 項目必須でチェックがついていない場合
    if (item.required && !checkboxOnFlg) {
      return MESSAGE_RESULT.NOT_SELECT(item.title);
    }

    // その他の項目の情報
    const otherTitle = JSON.parse(item.setting).other;
    const otherFlg = JSON.parse(item.setting).otherFlg;

    // その他の項目が選択されているときその他の入力テキストをチェック
    if (otherFlg && formData[fieldName + '_check_' + otherTitle]) {
      // 未入力チェック
      const requiredValidation = validateRequired(formData[fieldName + 'OtherText'], true, otherTitle);
      if (requiredValidation) return requiredValidation;

      // スペース入力、桁数、禁則文字チェック
      const otherValidation = validateCommonInput(formData[fieldName + 'OtherText'], 100, otherTitle);
      if (otherValidation) return otherValidation;
    }

    return MESSAGE_RESULT.OK; // 全て一致
  } catch (error) {
    return MESSAGE_RESULT.NOT_SELECT(item.title);
  }
};
export const checkIndependentRadiobuttonData = (inputStr, item, fieldName, formData) => {
  try {
    if (!item.required && inputStr === '') {
      return MESSAGE_RESULT.OK;
    }

    // JSON 文字列をパースしてオブジェクトに変換
    // （入力例）inputStr = {"0":"項目名"} 、その他の項目の場合は {"項目名":"項目名"}
    const inputObj = JSON.parse(inputStr);
    const valuesObj = JSON.parse(JSON.parse(item.setting).values);

    // その他の項目の情報
    const otherTitle = JSON.parse(item.setting).other;
    const otherFlg = JSON.parse(item.setting).otherFlg;

    // その他の項目が選択されているときその他の入力テキストをチェック
    let otherCheckFlg = false;
    if (otherFlg && inputStr.includes(otherTitle)) {
      // 未入力チェック
      const requiredValidation = validateRequired(formData[fieldName + 'OtherText'], true, otherTitle);
      if (requiredValidation) return requiredValidation;

      // スペース入力、桁数、禁則文字チェック
      const otherValidation = validateCommonInput(formData[fieldName + 'OtherText'], 100, otherTitle);
      if (otherValidation) return otherValidation;

      otherCheckFlg = true; // その他の項目がチェックされたフラグ
    }

    // inputObj のキーと値が valuesObj に含まれているか確認
    for (const [key, value] of Object.entries(inputObj)) {
      if (valuesObj[key] !== value && !otherCheckFlg) {
        return MESSAGE_RESULT.NOT_SELECT(item.title); // 一致しない項目がある場合
      }
    }

    return MESSAGE_RESULT.OK; // 全て一致
  } catch (error) {
    return MESSAGE_RESULT.NOT_SELECT(item.title);
  }
};

export const checkReason = (inputArray, max, itemName) => {
  // チェックボックスが選択されていない場合はエラー
  const checkedItems = inputArray.filter(item => item.checked);
  if (checkedItems.length === 0) {
    return MESSAGE_RESULT.NOT_CHECK;
  }

  // other の値が null でない項目(テキスト入力あり)の場合、テキスト入力値をバリデーション
  for (const item of checkedItems) {
    if (item.other !== null) {
      const inputStr = item.other;

      // 未入力の場合はエラー
      if (!inputStr) {
        return MESSAGE_RESULT.NOT_INPUT(itemName);
      }
      // 空白のみの場合はエラー
      if (isSpaceOnly(inputStr)) {
        return MESSAGE_RESULT.NOT_SPACE;
      }
      // 最大文字数を超えている場合はエラー
      else if (!isWithinMaxLength(inputStr, max)) {
        return MESSAGE_RESULT.OVER_DIGITS(itemName, max);
      }
      // 特殊文字が含まれている場合はエラー
      else if (!isNotContainSpecialCharacter(inputStr)) {
        return MESSAGE_RESULT.NOT_SPECIAL_CHARACTER(itemName);
      }
    }
  }

  // 上記のバリデーションをすべてパスした場合はOK
  return MESSAGE_RESULT.OK;
};

export const checkValidAgree = (inputStr) => {
  if (!inputStr) {
    return MESSAGE_RESULT.NOT_CHECK;
  } else {
    return MESSAGE_RESULT.OK;
  }
};

export const isWithinMaxLength = (inputStr, maxLength) => {
  return inputStr.length <= maxLength;
}

export const isSpaceOnly = (inputStr) => {
  const inputPattern = /^[\u0020\u3000]+$/;
  return inputPattern.test(inputStr);
}
// const isNameValid = (inputStr) => {
//   const inputPattern = /^[a-zA-Z\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF]+(\s[a-zA-Z\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF]+)?$/;
//   return inputPattern.test(inputStr);
// }

export const isKanaNameValid = (inputStr) => {
  const inputPattern = /^[\sア-ン゛゜ァ-ォャ-ョー「」、ヴ]{1,}$/;
  return inputPattern.test(inputStr);
}

export const isHankakuKanaNameValid = (inputStr) => {
  const inputPattern = /^[ｦ-ﾟ｡-ﾟ]+$/;
  return inputPattern.test(inputStr);
}

export const isEmailValid = (inputStr) => {
  const inputPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return inputPattern.test(inputStr);
}

export const isValidAlphanumeric = (inputStr) => {
  const alphanumericRegex = /^[a-zA-Z0-9]+$/;
  // const alphanumericRegex = /^((T|J)?[0-5][0-9]{8}|[0-9a-zA-Z]{8})$/;
  return alphanumericRegex.test(inputStr);
}

export const isValidNumeric = (inputStr) => {
  const numericRegex = /^[0-9]+$/;
  return numericRegex.test(inputStr);
}

export const isSellerCode = (inputStr) => {
  const sellerCodeRegex = /^(T|J)?[0-5][0-9]{8}$/;
  return sellerCodeRegex.test(inputStr);
}

export const isNotContainSpecialCharacter = (inputStr) => {
  const specialCharPattern = /^[^"&'<>]*$/;
  return specialCharPattern.test(inputStr);
}

export const isHankakuValid = (inputStr) => {
  const hankakuPattern = /^[ -~｡-ﾟ]+$/; // 半角文字と半角カタカナの正規表現
  return hankakuPattern.test(inputStr);
}

export const isZenkakuValid = (inputStr) => {
  const zenkakuPattern = /^[^ -~｡-ﾟ]+$/;  // 半角文字と半角カタカナ以外の正規表現
  return zenkakuPattern.test(inputStr);
}
